import React from 'react';

//Estilos
import { ComponenteExtra768Style } from './ComponenteExtra768Style';

export default function ComponenteExtra768({ Logo = '' }) {
    return (
        <div style={{ width: '100%' }}>
            <div style={ComponenteExtra768Style.DivStyle}>
                {Logo === null ? null : <img src={Logo} alt="BannerIcon" style={ComponenteExtra768Style.ImgStyle} />}
            </div>
        </div>
    );
}